import { render } from "./vhpDialog.vue?vue&type=template&id=5ee80261"
import script from "./vhpDialog.vue?vue&type=script&lang=js"
export * from "./vhpDialog.vue?vue&type=script&lang=js"

import "./vhpDialog.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__